import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

const ThankYou = () => {
  useEffect(() => {
    const violation = document.getElementById("top-menu");
    window.scrollTo({
      top: violation.offsetTop,
      // behavior: "smooth",
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>ThankYou</title>
        <meta name="keywords" content="" />
        <meta name="description" content="ThankYou " />
      </Helmet>
      <section id="thank_you_main" className="our_purposeSection">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-10 text-center">
              <div className="largeTxt">
                <h2 className="h2">Thank you for contacting us.</h2>
                We have noted down your request, and we will get back to you
                soon.
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ThankYou;
